import { render, staticRenderFns } from "./NgosSearch.vue?vue&type=template&id=2d1cd0f3&"
import script from "./NgosSearch.vue?vue&type=script&lang=js&"
export * from "./NgosSearch.vue?vue&type=script&lang=js&"
import style0 from "./NgosSearch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports